import React, { useEffect } from "react";
import { useOptimizerNavigation } from "./utility/useOptimizerNavigation";
import RuvnlOptimizerDas from "./OptimizerDas";
import RuvnlSimulationIndex from "./SimulateProcurement/SimulationIndex";
import { getProcurementDemoSession } from "../../../Rest_api/DemoRestApi";
import { setOptimizerDemoDateRange } from "../../../store/state/ProcurementOptimizer/DemoOptimizer/OptimizerDate";
import { setOptimizerDemoSession } from "../../../store/state/ProcurementOptimizer/DemoOptimizer/OptimizerSession";
import { setOptimizerDemoSessionToken } from "../../../store/state/ProcurementOptimizer/DemoOptimizer/OptimizerSessionToken";
import { useDispatch } from "react-redux";
import PowerIndex from "./PowerProcurement/PowerIndex";

const OptimizerRouter: React.FC = () => {
  const { currentPage } = useOptimizerNavigation();
  const dispatch = useDispatch();

  useEffect(() => {
    async function OptimizerRuvnlSession() {
      const data = await getProcurementDemoSession();
      if (data) {
        dispatch(
          setOptimizerDemoDateRange({
            startDate: data.start_date,
            endDate: data.end_date,
          })
        );
        dispatch(setOptimizerDemoSession(data.session));
        dispatch(setOptimizerDemoSessionToken(data.session_token));
      }
    }
    OptimizerRuvnlSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "power":
        return <PowerIndex />;
      case "simulation":
        return <RuvnlSimulationIndex />;
      default:
        return <RuvnlOptimizerDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default OptimizerRouter;
